import { createContext, useContext, useState } from "react";

const TransactionContext = createContext(undefined);

export const useTransaction = () => {
  const context = useContext(TransactionContext);

  if (!context) {
    throw new Error("useTransaction must be within TransactionProvider");
  }

  return context;
};

export const TransactionProvider = ({ children }) => {
  const [transactions, setTransactions] = useState([]);

  const addNewTransaction = (newTransaction) =>
    setTransactions([newTransaction, ...transactions]);

  const updateTransaction = (txId, updatedFields) => {
    setTransactions((prev) =>
      prev.map((tx) => (tx.txId === txId ? { ...tx, ...updatedFields } : tx))
    );
  };

  return (
    <TransactionContext.Provider
      value={{
        transactions,
        setTransactions,
        addNewTransaction,
        updateTransaction,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};
